<h2 mat-dialog-title><mat-icon>info</mat-icon> &nbsp; Customer Created</h2>
<mat-dialog-content class="mat-typography">
  <p>The customer has been created successfully.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>